/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { RolloutWaveTenantSummary } from './rolloutWaveTenantSummary';
import { RolloutType } from './rolloutType';
import { RolloutTargetState } from './rolloutTargetState';


/**
 * Summary of a rollout target for tenant display.
 */
export interface RolloutTargetTenantSummary { 
    /**
     * Rollout Target ID.
     */
    id?: string;
    /**
     * Rollout Target entity ID.
     */
    target_entity_id?: string;
    target_type?: RolloutTargetType;
    /**
     * Rollout Wave ID to which this target belongs.
     */
    wave_id?: string;
    /**
     * Rollout Plan ID to which this target belongs.
     */
    rollout_plan_id?: string;
    rollout_type?: RolloutType;
    /**
     * Scheduled execution start time for this target.
     */
    window_start_time?: Date;
    /**
     * Scheduled execution window end time for this target.
     */
    window_end_time?: Date;
    state?: RolloutTargetState;
    available_waves_to_reschedule?: Array<RolloutWaveTenantSummary>;
}
export namespace RolloutTargetTenantSummary {
}


